module.exports = __webpack_public_path__ + "img/1694659589746-IMG-20230914-WA0002.jpg.5a6fdcf3.webp";